import type { QuoteResponseDto } from '@trellis/api'
import { ConfirmDialog } from '@trellis/roots/overlays'

interface QuoteActionDialogsProps {
  quoteToDelete: QuoteResponseDto | null
  onDeleteOpenChange: (isOpen: boolean) => void
  onConfirmDelete: () => void
  isDeletePending: boolean
  markSentQuote: QuoteResponseDto | null
  onMarkSentOpenChange: (isOpen: boolean) => void
  onConfirmMarkSent: () => void
  isMarkSentPending: boolean
}

/** Delete + mark-sent confirmation dialogs shared between QuotesPage and ClientDetailPage. */
export function QuoteActionDialogs({
  quoteToDelete,
  onDeleteOpenChange,
  onConfirmDelete,
  isDeletePending,
  markSentQuote,
  onMarkSentOpenChange,
  onConfirmMarkSent,
  isMarkSentPending,
}: QuoteActionDialogsProps) {
  return (
    <>
      <ConfirmDialog
        open={quoteToDelete !== null}
        onOpenChange={onDeleteOpenChange}
        title="Are you absolutely sure?"
        description={
          <>
            This will permanently delete quote{' '}
            <strong>{quoteToDelete?.displayNumber}</strong>.
          </>
        }
        confirmLabel="Delete"
        isPending={isDeletePending}
        onConfirm={onConfirmDelete}
      />

      <ConfirmDialog
        open={markSentQuote !== null}
        onOpenChange={onMarkSentOpenChange}
        title="Mark quote as sent?"
        description={`This marks quote ${markSentQuote?.displayNumber} SENT without emailing the client. Line items can no longer be edited.`}
        confirmLabel="Mark as sent"
        isPending={isMarkSentPending}
        onConfirm={onConfirmMarkSent}
      />
    </>
  )
}
